export default {
  // Get all student exams (main exams)
  GET_ADMIN_STUDENT_EXAMS_MAIN_REQUEST: "GET_ADMIN_STUDENT_EXAMS_MAIN_REQUEST",
  GET_ADMIN_STUDENT_EXAMS_MAIN_SUCCESS: "GET_ADMIN_STUDENT_EXAMS_MAIN_SUCCESS",
  GET_ADMIN_STUDENT_EXAMS_MAIN_FAIL: "GET_ADMIN_STUDENT_EXAMS_MAIN_FAIL",

  // Redo exam
  REDO_EXAM_REQUEST: "REDO_EXAM_REQUEST",
  REDO_EXAM_SUCCESS: "REDO_EXAM_SUCCESS",
  REDO_EXAM_FAIL: "REDO_EXAM_FAIL",

  // Loading
  ADD_ADMIN_STUDENT_EXAMS_LOADING: "ADD_ADMIN_STUDENT_EXAMS_LOADING",
};

